import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import URLS from 'URLS';

// Material UI
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import { SxProps, Theme } from '@mui/material/styles';
import { floatingContainerSx } from './styles';

const OrderSchoolSubscriptionButton = ({
  floating,
  sx,
  keepDefaultColor = false,
  variant = 'free',
}: {
  floating?: boolean;
  sx?: SxProps<Theme>;
  keepDefaultColor?: boolean;
  variant?: 'free' | 'start' | 'year' | 'ukulele';
}) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  // TODO: Change text and navigate URL according to variant
  const text = t('LANDING.TRYFREE');

  const onClick = () => {
    // TODO: Navigate to correct site
    navigate(URLS.SCHOOLONBOARDING_INTEREST);
  };

  return (
    <>
      {floating ? (
        <Box sx={floatingContainerSx}>
          <Fab color={sx !== undefined && !keepDefaultColor ? undefined : 'primary'} onClick={onClick} sx={sx} variant={'extended'}>
            {text}
          </Fab>
        </Box>
      ) : (
        <Button color={sx !== undefined && !keepDefaultColor ? undefined : 'primary'} onClick={onClick} size={'large'} sx={sx} variant={'contained'}>
          {text}
        </Button>
      )}
    </>
  );
};

export default OrderSchoolSubscriptionButton;
